const searchForTab = (element, matchingId) => {
	if (matchingId.includes("*")) {
		throw new Error(
			"searchForTab doesn't support the wildcard ('*')! Replace it with the real path before calling the function."
		);
	}

	if (matchingId.includes("~")) {
		matchingId = matchingId.replace(/~[^.]+(?=\.|$)/g, "");
	}

	if (matchingId.includes(".") && Array.isArray(element)) {
		const splittedPath = matchingId.split(".");
		let r = null;

		for (let st of element) {
			if (st.id !== splittedPath[0]) continue;

			if (splittedPath.length === 1) {
				r = st;
				break;
			} else {
				if (!st.subTabs || st.subTabs.length === 0) break;
				splittedPath.shift();
				r = searchForTab(st.subTabs, splittedPath.join("."));
			}
		}

		return r;
	}

	if (matchingId.includes(".")) {
		const splittedPath = matchingId.split(".");
		if (!Array.isArray(element) && (!element?.subTabs || element.subTabs.length === 0)) return null;

		const newElement = (Array.isArray(element) ? element : element.subTabs).find(t => t.id === splittedPath[0]);
		let result = null;
		splittedPath.shift();

		if (splittedPath.length > 1) {
			result = searchForTab(newElement, splittedPath.join("."));
		}

		if (splittedPath.length === 1) {
			result = newElement;
		}

		return result;
	}

	if (Array.isArray(element)) {
		let r = null;

		for (let st of element) {
			if (st.id === matchingId) {
				r = st;
				break;
			}

			if (!st.subTabs) continue;

			for (let i = 0; !r && i < st.subTabs.length; i++) {
				r = searchForTab(st.subTabs[i], matchingId);
			}
		}

		return r;
	}

	if (element.id === matchingId) {
		return element;
	}

	if (!element.subTabs) return null;

	let result = null;
	for (let i = 0; !result && i < element.subTabs.length; i++) {
		result = searchForTab(element.subTabs[i], matchingId);
	}

	return result;
};

export default searchForTab;
